
// Stylesheets
require('./node_modules/bootstrap/scss/bootstrap.scss');
require('./node_modules/font-awesome/scss/font-awesome.scss');
require('./src/_assets/css/main.scss');

// Javascript
require('./node_modules/bootstrap/dist/js/bootstrap.min');
require('./node_modules/jquery-mask-plugin/dist/jquery.mask.min');

require('./src/_assets/js/app');
require('./src/_assets/js/form-validation');
require('./src/_assets/js/disqus_comments');
require('./src/_assets/js/facebook_likes');
require('./src/_assets/js/google_analytics');
require('./src/_assets/js/google_search');
require('./src/_assets/js/twitter_sharing');

// Images
require('./src/_assets/img/carousel-0.jpg');
require('./src/_assets/img/carousel-1.jpg');
require('./src/_assets/img/carousel-2.jpg');
require('./src/_assets/img/carousel-3.jpg');
require('./src/_assets/img/carousel-4.jpg');
require('./src/_assets/img/cad.jpg');
require('./src/_assets/img/defibrillator.png');
require('./src/_assets/img/billing.png');
require('./src/_assets/img/emstars.jpg');
require('./src/_assets/img/nemsis.gif');
require('./src/_assets/img/nfirs.png');
require('./src/_assets/img/chris.gif');
require('./src/_assets/img/john.png');
require('./src/_assets/img/nemsis.png');

// Favicon(s) (force the file-loader)
require('file-loader?name=[name].[ext]&outputPath=../../!./src/_assets/img/android-chrome-192x192.png');
require('file-loader?name=[name].[ext]&outputPath=../../!./src/_assets/img/android-chrome-512x512.png');
require('file-loader?name=[name].[ext]&outputPath=../../!./src/_assets/img/apple-touch-icon.png');
require('file-loader?name=[name].[ext]&outputPath=../../!./src/_assets/img/browserconfig.xml');
require('file-loader?name=[name].[ext]&outputPath=../../!./src/_assets/img/favicon-16x16.png');
require('file-loader?name=[name].[ext]&outputPath=../../!./src/_assets/img/favicon-32x32.png');
require('file-loader?name=[name].[ext]&outputPath=../../!./src/_assets/img/favicon.ico');
require('file-loader?name=[name].[ext]&outputPath=../../!./src/_assets/img/manifest.json');
require('file-loader?name=[name].[ext]&outputPath=../../!./src/_assets/img/mstile-70x70.png');
require('file-loader?name=[name].[ext]&outputPath=../../!./src/_assets/img/mstile-144x144.png');
require('file-loader?name=[name].[ext]&outputPath=../../!./src/_assets/img/mstile-150x150.png');
require('file-loader?name=[name].[ext]&outputPath=../../!./src/_assets/img/mstile-310x150.png');
require('file-loader?name=[name].[ext]&outputPath=../../!./src/_assets/img/mstile-310x310.png');
require('file-loader?name=[name].[ext]&outputPath=../../!./src/_assets/img/safari-pinned-tab.svg');



// WEBPACK FOOTER //
// ./webpack.js